var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcdonaldsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 610.5 533.3",
    style: {
      enableBackground: "new 0 0 610.5 533.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.6,37.9c52.5,0,95.2,221.7,95.2,495.4h76.7C610.5,238.6,533.1,0,438.4,0c-54.1,0-101.9,71.5-133.5,183.8 C273.3,71.5,225.5,0,171.8,0C77.1,0,0,238.4,0,533.1h76.7c0-273.8,42.2-495.2,94.7-495.2s95.2,204.8,95.2,457.3h76.2 c0-252.6,42.8-457.3,95.4-457.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcdonaldsLogo);
export default __webpack_public_path__ + "static/media/mcdonalds-logo.37f19d7c3044277963ff36f7a853b842.svg";
export { ForwardRef as ReactComponent };